export enum BulkUpdateContentTypeEnum {
    PostStudies = 'PostStudies',
    AwaitingCurationStudies = 'AwaitingCurationStudies',
    PropertyUpdate = 'PropertyUpdate',
}
